export default __webpack_public_path__ + "static/media/mx-step2.632d76a7.png";